import {AbstractFilter} from '@gongxigames/framework/slot';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {WolfHavenSpin} from 'com/gongxigames/math/wolfhaven/engine/WolfHavenSpin';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class RandomWildFeatureFilter extends AbstractFilter {
    public filter(response: Message): boolean {
        if (response.getAction() === Action.SPIN || response.getAction() === Action.FREESPIN) {
            const spin = (this.getSpin(response) as WolfHavenSpin);

            return spin.getWildsAward().length > 0;
        }

        return true;
    }
}
